import { useLingui } from "@lingui/react/macro";

/**
 * What the dialog and the window put in their title bar.
 *
 * A hook rather than a function taking `t`: a lingui `t` handed to another
 * function renders empty strings, without saying so.
 */
export function useShellTitle(clientId: number | null): string {
  const { t } = useLingui();

  return null === clientId ? t`New client` : t`Client`;
}
